import React from "react";
import { fromPublic } from "../../../../utils";
import { ErrorContainer, InfoText, BoldText, WarningIcon } from "../styles";

interface ErrorStateProps {
  onRefresh: () => void;
  title: string;
  subtitle: string;
  icon: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  onRefresh,
  title,
  subtitle,
  icon,
}) => (
  <ErrorContainer onClick={onRefresh}>
    <WarningIcon src={fromPublic(icon)} alt="Warning" />
    <InfoText>{title}</InfoText>
    <InfoText>
      <BoldText>{subtitle}</BoldText>
    </InfoText>
  </ErrorContainer>
);

export default ErrorState;
